// extracted by mini-css-extract-plugin
export var chevronIcon = "_c2-2";
export var teamName = "_c2-1";
export var teamSwitcherButton = "_c2-0";